module.exports = __webpack_public_path__ + "img/logo.e5b11bb5.png";